import {
  humanFileSize, localeDate, localeDateTime, numberFormat, summaryText,
} from '../utils/utils'

export default {
  install(Vue) {
    Vue.filter('numberFormat', numberFormat)
    Vue.filter('localeDate', localeDate)
    Vue.filter('localeDateTime', localeDateTime)
    Vue.filter('humanFileSize', humanFileSize)
    Vue.filter('summaryText', summaryText)
  },
}
